import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { boatInfo } from '../data/mock';
import { BookingForm } from './BookingForm';

export const Contact = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-white to-blue-50/30 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-blue-100/40 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-orange-100/40 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="mb-4 bg-blue-100 text-blue-700 hover:bg-blue-200">
            <MapPin className="w-4 h-4 mr-1" />
            Réservation & Contact
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Réservez votre
            <span className="bg-gradient-to-r from-blue-600 to-blue-800 bg-clip-text text-transparent"> aventure</span>
          </h2>
          <p className="text-lg text-gray-600">
            Système de réservation en ligne avec paiement sécurisé
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-12 max-w-7xl mx-auto">
          {/* Booking Form - Takes 2 columns */}
          <div className="lg:col-span-2">
            <BookingForm />
          </div>

          {/* Map & Contact Info */}
          <div className="space-y-6">
            {/* Google Map */}
            <Card className="shadow-2xl border-2 overflow-hidden">
              <div className="h-64">
                <iframe
                  src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2893.8!2d${boatInfo.location.coordinates.lng}!3d${boatInfo.location.coordinates.lat}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDPCsDE0JzM2LjIiTiA1wrAyMScyMy4wIkU!5e0!3m2!1sfr!2sfr!4v1234567890`}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Localisation The Myli Boat"
                ></iframe>
              </div>
            </Card>

            {/* Contact Details */}
            <Card className="shadow-2xl border-2">
              <CardHeader>
                <CardTitle className="text-xl">Informations de Contact</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors">
                  <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                    <MapPin className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Adresse</h4>
                    <p className="text-gray-600">{boatInfo.location.address}</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors">
                  <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                    <Phone className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Téléphone</h4>
                    <a href={`tel:${boatInfo.contact.phoneRaw}`} className="text-blue-600 hover:text-blue-800 font-medium">
                      {boatInfo.contact.phone}
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4 p-4 bg-blue-50 rounded-xl hover:bg-blue-100 transition-colors">
                  <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                    <Mail className="w-5 h-5 text-white" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">Email</h4>
                    <a href={`mailto:${boatInfo.contact.email}`} className="text-blue-600 hover:text-blue-800 font-medium">
                      {boatInfo.contact.email}
                    </a>
                  </div>
                </div>

                <div className="mt-6 p-4 bg-gradient-to-r from-orange-500 to-pink-500 rounded-xl text-white">
                  <h4 className="font-bold text-lg mb-2">Horaires d'ouverture</h4>
                  <p className="text-sm text-white/90">
                    Saison estivale (1er juin - 15 sept) : Tous les jours<br />
                    Hors saison : Sur réservation
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};
